module.exports = __webpack_public_path__ + "static/img/y2.abe7f74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y2.jpg
// module id = OKVs
// module chunks = 1